import { combineReducers } from 'redux';
import modalReducer from '../../components/modals/modal-reducer';
import commonReducer from './common';
import configurationReducer from './configuration';
import corporateReducer from './corporate';
import ncnsReducer from './ncns';
import stormReducer from './storm-map';
import systemConfigReducer from './systemConfig';
import ptoReducer from './time-off';
import timesheetReducer from './timesheet';

const rootReducer = combineReducers({
  systemConfigReducer,
  modalReducer,
  commonReducer,
  configurationReducer,
  timesheetReducer,
  corporateReducer,
  ptoReducer,
  ncnsReducer,
  stormReducer,
});
export type RootState = ReturnType<typeof rootReducer>;
export default rootReducer;
